"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitChangePaymentDayPage = exports.DirectDebitChangePaymentDayPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Types_1 = require("../../Types");
var Notification_1 = require("../Notification");
var DirectDebitChangePaymentDayPagePlain = /** @class */ (function (_super) {
    __extends(DirectDebitChangePaymentDayPagePlain, _super);
    function DirectDebitChangePaymentDayPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.policyNumber = _this.props.params.number;
        _this.customerReference = _this.props.params.id;
        _this.interactionId = _this.props.params.interactionId;
        _this.state = {
            newPaymentDay: 0,
            showNoDaySelectedAlert: false,
            showOverlay: false,
            paymentDayOptions: []
        };
        _this.updatePaymentDay = _this.updatePaymentDay.bind(_this);
        _this.saveAndConfirm = _this.saveAndConfirm.bind(_this);
        _this.cancelChanges = _this.cancelChanges.bind(_this);
        _this.closeNoPaymentDaySelectedModal = _this.closeNoPaymentDaySelectedModal.bind(_this);
        _this.renderAlert = _this.renderAlert.bind(_this);
        return _this;
    }
    DirectDebitChangePaymentDayPagePlain.prototype.componentDidMount = function () {
        document.title = "Change your payment day";
        this.loadInteraction();
        this.fetchAvailablePaymentDays();
    };
    DirectDebitChangePaymentDayPagePlain.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.templates.renderHeader(), this.templates.renderBackLink("Customer details", true, "/customers/".concat(this.customerReference)), (0, jsx_runtime_1.jsxs)("div", { className: "plugin", children: [this.renderPageTitle(), this.renderAvailablePaymentDaysBanner(), this.renderChangePaymentDatePanel(), this.renderNavigationButtons()] }), this.templates.renderFooter(), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay }), this.renderAlert()] }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.fetchAvailablePaymentDays = function () {
        var _this = this;
        this.supportPortalService
            .getAvailablePaymentDays(this.customerReference, this.policyNumber)
            .subscribe(function (paymentDayOptions) { return _this.setState({ paymentDayOptions: paymentDayOptions }); });
    };
    DirectDebitChangePaymentDayPagePlain.prototype.loadInteraction = function () {
        var _this = this;
        this.supportPortalService
            .getInteraction(this.interactionId)
            .subscribe(function (interaction) {
            _this.setState({ interaction: interaction });
        });
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderPageTitle = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "text-group title plugin no-indent-desktop", children: (0, jsx_runtime_1.jsx)("h1", { children: "Change your payment day" }) }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderAvailablePaymentDaysBanner = function () {
        var _a;
        var daysAvailable = (_a = this.state.paymentDayOptions) === null || _a === void 0 ? void 0 : _a.length;
        if (daysAvailable === undefined || daysAvailable === 28) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        else if (daysAvailable === 0) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "banner banner-warn", children: (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsx)("p", { children: "You can not change your payment date as it will mean the last monthly payment will be after the policy end date." }) }) }));
        }
        else {
            var lastPaymentDayOption = this.state.paymentDayOptions[daysAvailable - 1];
            return ((0, jsx_runtime_1.jsx)("div", { className: "banner banner-warn", children: (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsxs)("p", { children: ["You can only choose from ", (0, jsx_runtime_1.jsx)("b", { children: "1st" }), " to ", (0, jsx_runtime_1.jsx)("b", { children: lastPaymentDayOption }), " of the month as a payment date. Otherwise, your last monthly payment will be after policy end date."] }) }) }));
        }
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderChangePaymentDatePanel = function () {
        var _a;
        return ((0, jsx_runtime_1.jsx)("div", { className: "panel", children: (0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "changePaymentDayQuestion", children: "Which day of the month should we take your payment?" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsx)("select", { id: "changePaymentDayQuestion", className: "form-control null", onChange: this.updatePaymentDay, value: this.state.newPaymentDay, disabled: !this.state.paymentDayOptions || ((_a = this.state.paymentDayOptions) === null || _a === void 0 ? void 0 : _a.length) === 0, children: this.renderPaymentDayOptions() }) })] }) }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.updatePaymentDay = function (event) {
        var selectedDate = parseInt(event.target.value, 10);
        this.setState(function (previousState) {
            var _a;
            return ({
                newPaymentDay: (isNaN(selectedDate) ? (_a = previousState.interaction) === null || _a === void 0 ? void 0 : _a.paymentDay : selectedDate)
            });
        });
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderPaymentDayOptions = function () {
        if (!this.state.paymentDayOptions) {
            return (0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." });
        }
        var index = 0;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("option", { value: 0, children: "Please select..." }), this.state.paymentDayOptions.map(function (option) {
                    return ((0, jsx_runtime_1.jsx)("option", { className: option, value: ++index, children: option }, index));
                })] }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderNavigationButtons = function () {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-white-dashboard margin-y40", onClick: this.cancelChanges, children: "Cancel" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-default btn-primary float-right", onClick: this.saveAndConfirm, disabled: !this.state.paymentDayOptions || ((_a = this.state.paymentDayOptions) === null || _a === void 0 ? void 0 : _a.length) === 0, children: "Save and confirm" })] }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.saveAndConfirm = function () {
        var _this = this;
        var allowedPaymentDay = this.state.newPaymentDay !== 0;
        this.setState({
            showOverlay: true
        });
        if (allowedPaymentDay) {
            this.supportPortalService.storePaymentDay(this.customerReference, this.policyNumber, this.state.newPaymentDay).subscribe(function () {
                _this.setState({
                    showNoDaySelectedAlert: false
                });
                _this.props.navigate("/customers/".concat(_this.customerReference));
            });
        }
        else {
            this.setState({
                showNoDaySelectedAlert: true,
                showOverlay: false
            });
        }
    };
    DirectDebitChangePaymentDayPagePlain.prototype.cancelChanges = function () {
        this.props.navigate("/customers/".concat(this.customerReference));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.renderAlert = function () {
        return ((0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showNoDaySelectedAlert, hide: this.closeNoPaymentDaySelectedModal, title: "Warning!", message: "Please select a payment date to continue." }));
    };
    DirectDebitChangePaymentDayPagePlain.prototype.closeNoPaymentDaySelectedModal = function () {
        this.setState(function (prevState) { return ({
            showNoDaySelectedAlert: !prevState.showNoDaySelectedAlert
        }); });
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], DirectDebitChangePaymentDayPagePlain.prototype, "supportPortalService", void 0);
    DirectDebitChangePaymentDayPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], DirectDebitChangePaymentDayPagePlain);
    return DirectDebitChangePaymentDayPagePlain;
}(React.Component));
exports.DirectDebitChangePaymentDayPagePlain = DirectDebitChangePaymentDayPagePlain;
exports.DirectDebitChangePaymentDayPage = (0, components_1.withRouter)(DirectDebitChangePaymentDayPagePlain);
//# sourceMappingURL=DirectDebitChangePaymentDayPage.js.map